// extracted by mini-css-extract-plugin
export default {"nav":"principalMenu_style_nav__ZKjBB","itemMenu":"principalMenu_style_itemMenu__zc950"};